import {
  Typography,
  Box,
  IconButton,
  Card,
  CardContent,
  Container,
} from "@mui/material";

import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import SalesImg from "../../Images/AppImg/SalesImg.png";
import PurchaseImg from "../../Images/AppImg/PurchaseImg.png";
import ReceiptsImg from "../../Images/AppImg/ReceiptsImg.png";
import PaymentsImg from "../../Images/AppImg/PaymentsImg.png";
import EWayImg from "../../Images/AppImg/EWayImg.png";
import ReportsImg from "../../Images/AppImg/ReportsImg.png";
function ScreenShot() {
  const Details = [
    {
      img: SalesImg,
      title: "Sales & Inventory Management",
      description:
        "Track sales, manage stock levels, and streamline your invoicing process with real-time updates.",
    },
    {
      img: PurchaseImg,
      title: "Purchase Management",
      description:
        "Simplify vendor bills, track expenses, and manage purchase orders with ease.",
    },
    {
      img: ReceiptsImg,
      title: "Receipts Tracking",
      description:
        "Record and organize customer receipts, ensuring transparent cash flow and accurate accounts.",
    },
    {
      img: PaymentsImg,
      title: "Payments Management",
      description:
        "Easily manage outgoing payments to vendors and suppliers with clear transaction history.",
    },
    {
      img: EWayImg,
      title: "E-Way Bill Integration",
      description:
        "Generate and manage e-Way Bills directly from the app, fully compliant with GST rules.",
    },
    {
      img: ReportsImg,
      title: "Comprehensive Reports",
      description:
        "Get powerful insights with financial, tax, and business performance reports — all in one place.",
    },
  ];
  return (
    <div>
      <Box
        sx={{
          py: { xs: 4, md: 8 },
          backgroundColor: "background.paper",
          backgroundImage:
            "linear-gradient(to bottom, #f7fbff 0%, #ffffff 100%)",
          overflow: "hidden",
        }}
      >
        <Container maxWidth="lg">
          <Box textAlign="center" sx={{ mb: 6 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 800,
                mb: 2,
                color: "primary.main",
              }}
            >
              App Experience
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ maxWidth: 600, mx: "auto" }}
            >
              Discover our intuitive interface designed to streamline your
              accounting workflow
            </Typography>
          </Box>

          {/* Horizontal scrolling container */}
          <Box
            sx={{
              position: "relative",
              "&:hover .scroll-arrows": {
                opacity: 1,
              },
            }}
          >
            {/* Left arrow */}
            <IconButton
              className="scroll-arrows"
              sx={{
                position: "absolute",
                left: 0,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 2,
                backgroundColor: "background.paper",
                boxShadow: 2,
                opacity: 0,
                transition: "opacity 0.3s",
                "&:hover": {
                  backgroundColor: "primary.main",
                  color: "white",
                },
              }}
              onClick={() => {
                const container = document.getElementById("scroll-container");
                container.scrollBy({ left: -300, behavior: "smooth" });
              }}
            >
              <ChevronLeft />
            </IconButton>

            {/* Scrollable container */}
            <Box
              id="scroll-container"
              sx={{
                display: "flex",
                overflowX: "auto",
                gap: 3,
                py: 2,
                px: 1,
                scrollBehavior: "smooth",
                "&::-webkit-scrollbar": {
                  height: 6,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "grey.100",
                  borderRadius: 3,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "primary.main",
                  borderRadius: 3,
                },
              }}
            >
              {Details.map((n, index) => (
                <Card
                  key={index}
                  sx={{
                    flex: "0 0 auto",
                    width: 500,
                    borderRadius: 2,
                    overflow: "hidden",
                    transition: "transform 0.2s, box-shadow 0.2s",
                    border: "1px solid",
                    borderColor: "divider",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: 4,
                    },
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      overflow: "hidden",
                      backgroundColor: "#f0f4f8",
                      // height: 200,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      component="img"
                      src={n.img}
                      alt={n.title}
                      sx={{
                        width: "100%",
                        height: "auto",
                        borderRadius: 1,
                        boxShadow: 2,
                      }}
                    />
                  </Box>
                  <CardContent sx={{ p: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                      {n.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {n.description}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>

            {/* Right arrow */}
            <IconButton
              className="scroll-arrows"
              sx={{
                position: "absolute",
                right: 0,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 2,
                backgroundColor: "background.paper",
                boxShadow: 2,
                opacity: 0,
                transition: "opacity 0.3s",
                "&:hover": {
                  backgroundColor: "primary.main",
                  color: "white",
                },
              }}
              onClick={() => {
                const container = document.getElementById("scroll-container");
                container.scrollBy({ left: 300, behavior: "smooth" });
              }}
            >
              <ChevronRight />
            </IconButton>
          </Box>

          {/* Dots indicator */}
          <Box
            sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 1 }}
          >
            {[1, 2, 3].map((dot) => (
              <Box
                key={dot}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: "primary.main",
                  opacity: 0.3,
                  cursor: "pointer",
                  "&:hover": {
                    opacity: 0.7,
                  },
                }}
                onClick={() => {
                  const container = document.getElementById("scroll-container");
                  container.scrollTo({
                    left: (dot - 1) * 960,
                    behavior: "smooth",
                  });
                }}
              />
            ))}
          </Box>
        </Container>
      </Box>
    </div>
  );
}

export default ScreenShot;
